
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/bollettino-neve",
      function () {
        return require("private-next-pages/[region]/bollettino-neve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/bollettino-neve"])
      });
    }
  